import { Button, Form, Input, Modal, Space } from "antd";
import axios from "axios";
import React, { useContext } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const EditCredentials = ({ open, close, data, getMyCommissaryInfo }) => {
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const handleUpdateCredentialCom = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    axios
      .post("user/commissary/update-credentials", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated credentials successfully.");
          setTimeout(() => {
            close();
            getMyCommissaryInfo();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{
          username: data.cominfouser.username,
          password: "",
        }}
        onFinish={handleUpdateCredentialCom}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="username"
            label="Username"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set username" size="large" />
          </Form.Item>

          <Form.Item
            // style={{ marginBottom: "5px" }}
            name="password"
            label="Password"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password
              // prefix={<LockOutlined />}
              placeholder="Set password"
              size="large"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditCredentials;
